/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum StrapiGraphQLURL {
    DEV = 'https://ct.dev.virginmediao2.co.uk/graphql',
    INT = 'https://ct.int.virginmediao2.co.uk/graphql',
    STAGING = 'https://ct.stage.virginmediao2.co.uk/graphql',
    PROD = 'https://ct.virginmediao2.co.uk/graphql',
  }
  
  export enum StrapiGraphQLLegacyURL {
    DEV = 'https://ct.dev.virginmedia.com/graphql',
    INT = 'https://ct.int.virginmedia.com/graphql',
    STAGING = 'https://ct.stage.virginmedia.com/graphql',
    PROD = 'https://ct.virginmedia.com/graphql',
  }
  
  export enum StrapiAssetsURL {
    DEV = 'https://dev.ctassets.virginmedia.com',
    INT = 'https://prod.ctassets.virginmedia.com',
    STAGING = 'https://prod.ctassets.virginmedia.com',
    PROD = 'https://prod.ctassets.virginmedia.com',
  }
  